import { z } from 'zod';

// The `actions` slot's schema. An ordered list of action-command refs
// (SurfaceRuntime keys) resolving to command descriptors + run behaviour. The
// list order is the render order. Refs are validated as strings — they resolve
// to `actionCommands` runtime capabilities at compile/mount time.
export const ActionsSlotSchemaZod = z.object({
  commands: z.array(z.string().min(1)),
}).strict();

export type ActionsSlotSchema = z.infer<typeof ActionsSlotSchemaZod>;
